/**
 * Cart Bundle Cleanup Script
 * Ensures that free gifts associated with a bundle are removed when the bundle itself is removed.
 * Linkage is established via the '_BundleKey' line item property.
 * Gifts are identified by the presence of '_Gift' property and '_BundleKey'.
 */

(function () {
    let isUpdating = false;

    function cleanupBundles(cart) {
        if (isUpdating) return;

        const items = cart.items;
        const bundleKeys = new Set();
        const giftsToRemove = [];

        // 1. Identify all active Bundle Keys from non-gift items
        items.forEach((item) => {
            const props = item.properties || {};
            // If it has a bundle key but is NOT a gift, it's a parent bundle item
            if (props['_BundleKey'] && !props['_Gift']) {
                bundleKeys.add(props['_BundleKey']);
            }
        });

        // 2. Find orphaned gifts
        items.forEach((item) => {
            const props = item.properties || {};
            if (props['_Gift'] && props['_BundleKey']) {
                // If this gift's bundle key is NOT in the active set, it's an orphan
                if (!bundleKeys.has(props['_BundleKey'])) {
                    giftsToRemove.push(item);
                }
            }
        });

        if (giftsToRemove.length > 0) {
            console.log('Cleanup: Removing orphaned gifts', giftsToRemove);
            removeItems(giftsToRemove);
        }
    }

    function removeItems(items) {
        isUpdating = true;
        const updates = {};

        items.forEach(item => {
            updates[item.key] = 0;
        });

        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates: updates })
        })
            .then(response => response.json())
            .then(cart => {
                isUpdating = false;
                // Refresh UI if needed
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                // Also trigger other common events
                if (window.publish && window.PUB_SUB_EVENTS) {
                    window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                        source: 'cart-cleanup',
                        cartData: cart
                    });
                }

                // Force reload cart drawer if it exists
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer && cartDrawer.renderContents) {
                    cartDrawer.renderContents(cart);
                }
            })
            .catch(error => {
                console.error('Cleanup Error:', error);
                isUpdating = false;
            });
    }

    // Monitor Cart Updates

    // Method 1: Listen for fetch at the network level (optional, but robust)
    // We'll rely on events first.

    // Listen to common theme events
    document.addEventListener('cart:updated', () => {
        fetch('/cart.js').then(r => r.json()).then(cleanupBundles);
    });

    // Also hook into the global fetch to catch cart/change calls if events aren't reliable
    const originalFetch = window.fetch;
    window.fetch = function () {
        return originalFetch.apply(this, arguments).then((response) => {
            if (response.url.includes('/cart/add') ||
                response.url.includes('/cart/change') ||
                response.url.includes('/cart/update') ||
                response.url.includes('/cart/clear')) {
                response.clone().json().then(data => {
                    // If it looks like a cart object
                    if (data.items) {
                        cleanupBundles(data);
                    } else if (response.url.includes('/cart/add')) {
                        // Add returns the item added, so we should fetch full cart
                        fetch('/cart.js').then(r => r.json()).then(cleanupBundles);
                    }
                }).catch(e => {
                    // Not JSON or other error, safe to ignore
                });
            }
            return response;
        });
    };

    // Initial check on load
    fetch('/cart.js')
        .then((response) => response.json())
        .then(cleanupBundles)
        .catch(console.error);

})();
